import { debug } from "../../../helpers/debug";

/*------------------------------------*\
  #FORMS CONTROL

  Class gestion des formulaires

\*------------------------------------*/
class Control {

  constructor(module){
    this.ERR_ALPHA = "Seuls les lettres et caractères spéciaux suivants ( - ' ) sont acceptés";
    this.ERR_ALPHA_NUM = "Seuls les lettres, chiffres et caractères spéciaux suivants ( - _ ) sont acceptés";
    this.ERR_NUMBER = "Saisissez uniquement des chiffres (de 0 à 9)";
    this.ERR_NUMBER_DEMANDE = "Saisissez les 8 chiffres transmis par le Service Consommateurs";
    this.ERR_CP = "Saisissez 5 chiffres uniquement (de 0 à 9)";
    this.ERR_PHONE = "Numéro de téléphone non valide pour la France ou Monaco.";
    this.ERR_EMAIL = "Veuillez saisir une adresse email valide, par exemple : nom.prenom@domaine.fr";
    this.ERR_DATE = "Renseignez la date au format suivant : JJ/MM/AAAA";
    this.ERR_DATE_LATER = "La date saisie doit être supérieure à la date du jour";
    this.ERR_REQUIRED = "Ce champ est obligatoire";
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {

    if(debug.DEBUG) console.log('async/form/modules/controls.js');
  }

  isAlpha = value => /^[ýŸ¡¿çœßøåæÞþÐða-z\-'\u00E0-\u00FC ]*$/i.test(value);
  isAlphaNum = (value) => /^[ýŸ¡¿çœßøåæÞþÐða-z\-\_\u00E0-\u00FC0-9 ]*$/i.test(value);
  isNumber = value => /^[0-9]*$/.test(value);
  isNumberDemande = (value) => {
    return value.length === 8 && value !== "00000000" && !isNaN(value);
  }
  isCp = (value) => value.length === 5 && !isNaN(value);
  isPhone = (value, indicatif) => {
    var regExDefault = /^((0[1-9][0-9])|9)[0-9]{7}$/i;
    var regexFranceIndicatif = /^0[1-9][0-9]{8}$/i;
    var regexMonacoIndicatif = /^((0[6-7][0-9])|9)[0-9]{7}$/i;
    var regex = indicatif ? indicatif === '+33' ? regexFranceIndicatif : regexMonacoIndicatif : regExDefault;
    if (value.length === 0) return true;
    return regex.test(value.replace(/\s/g, ''));// oblige de parcourir la chaîne de caracteres jusqa'au bout
  }
  isEmail = (value) => {
    var regex = /^([\w-]+(?:[\.|\+][\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,20}(?:\.[a-z]{2})?)$/i;
    return regex.test(value);
  }
  isDate = (value) => {
    var regex = /^([012][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d{2}$/i;
    
    if (!regex.test(value)) return false;

    let parts = value.split("/");
    let day = parseInt(parts[0], 10);
    let month = parseInt(parts[1], 10);
    let year = parseInt(parts[2], 10);

    let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    // Adjust for leap years
    if (year % 4 == 0)
        monthLength[1] = 29;
    console.log(day <= monthLength[month - 1])
    return day <= monthLength[month - 1];
  }
  isDateLater = (value) => {
    let dateSplit = value.split('/');
    let i18nValue = dateSplit[1] + '/' + dateSplit[0] + '/' + dateSplit[2];
    let oneDay = (1000 * 60 * 60 * 24);
    let tomorrow = (new Date().setHours(0, 0, 0, 0) + oneDay);
    if (tomorrow > new Date(i18nValue).getTime()) return false;
    return true;
  }

  check = (input) => {
    let error = false;
    let message = '';
    const controls = input.getAttribute('data-js-form-controls')?.replace(' ', '').split(',') || [];
  
    const validators = {
      'alpha': { method: this.isAlpha, error: this.ERR_ALPHA },
      'alpha-num': { method: this.isAlphaNum, error: this.ERR_ALPHA_NUM },
      'number': { method: this.isNumber, error: this.ERR_NUMBER },
      'number-demande': { method: this.isNumberDemande, error: this.ERR_NUMBER_DEMANDE },
      'cp': { method: this.isCp, error: this.ERR_CP },
      'phone': { method: (value) => this.isPhone(value, this.getIndicatif(input)), error: this.ERR_PHONE },
      'email': { method: this.isEmail, error: this.ERR_EMAIL },
      'date': { method: this.isDate, error: this.ERR_DATE },
      'date-later': { method: (value) => this.isDate(value) && this.isDateLater(value), error: this.ERR_DATE_LATER }
    };
  
    for (const control of controls) {
      if (validators[control] && !validators[control].method(input.value)) {
        error = true;
        message = validators[control].error;
        break;
      }
    }
  
    if (!error && input.required) {
      if (input.value === '' || (/radio|checkbox/i.test(input.type) && !document.querySelectorAll(`input[name="${input.name}"]:checked`).length)) {
        error = true;
        message = this.ERR_REQUIRED;
      }
    }
  
    return { error, message };
  }

  getIndicatif = (element) => {
    const indicatifGroup = element.closest('form')?.querySelector('#indicatif-group');
    return indicatifGroup?.value;
  }
}
export default new Control(); 